// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fctl-label-withhelpertext {
  align-items: center;
  display: inline-flex;
  gap: var(--pf-t--global--spacer--xs);
}

.fctl-label-withhelpertext.fctl-label-withhelpertext--inline .pf-v6-c-button {
  --pf-v6-c-button--PaddingBlockEnd: 0;
  --pf-v6-c-button--PaddingBlockStart: 0;
}
`, "",{"version":3,"sources":["webpack://./../../libs/ui-components/src/components/common/WithHelperText.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC","sourcesContent":[".fctl-label-withhelpertext {\n  align-items: center;\n  display: inline-flex;\n  gap: var(--pf-t--global--spacer--xs);\n}\n\n.fctl-label-withhelpertext.fctl-label-withhelpertext--inline .pf-v6-c-button {\n  --pf-v6-c-button--PaddingBlockEnd: 0;\n  --pf-v6-c-button--PaddingBlockStart: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
